import * as React from 'react';
import { AppConstants } from '../../constants/AppConstants';
import I18nActions from './i18n_actions'
import { connect } from 'react-redux';
import {isAuth} from 'arm-common'
import * as agui from 'arm-gui/dist/controls';


class Localizzazione extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = "[Localizzazione.jsx] ";
        this.createI18n = this.createI18n.bind(this);
        this.detailsOnClick = this.detailsOnClick.bind(this);
        this.esportaButton = this.esportaButton.bind(this);
        this.inputChangeHandler = this.inputChangeHandler.bind(this);
        this.filterLocalizzazione = this.filterLocalizzazione.bind(this);

        this.state = {
            searchPar: '',
        }
    }
    columnDetail(value, row, index) {
        //console.log("columnDetail:" + index);
        let temp;
        temp = "<button class='btn btn-info btn-sm'><i class='fas fa-info fa-fw'/></button>";
        return temp;
    }

    detailsOnClick(row, $element, field) {
        console.log(this.componentName + "detailsOnClick [field] " + field);

        this.props.history.push({ pathname: '/impostazioni/localizzazioneDetails', state: { id: row.id.code } });
    }

    createI18n() {
        this.props.history.push('/impostazioni/localizzazioneCreate');
        // this.props.setLang();
        // this.props.clearAll();
    }
    componentDidMount() {
        console.log(this.componentName + ' componentDidMount');

        let columns = [
            { field: 'id.code', title: 'ID', sortable: 'true' },
            { title: 'Dettagli', formatter: this.columnDetail }
        ];

        $(this.refs.I18nTable).bootstrapTable({
            columns: columns,
            idField: "id",
            sortable: true,
            search: true,
            showColumns: true,
            showExport: true,
            exportDataType: 'all',
            exportTypes: ['csv', 'excel'],

            onClickRow: (row, $element) => this.detailsOnClick(row, $element),
            sortOrder: "desc",
            pagination: true,

        });

        //effettuo la chimata rest per recuperare i dati
        this.props.clearSearchPar();
        this.props.getI18nList();
    }

    componentWillReceiveProps(nextProps) {
        console.log(this.componentName + ' componentWillReceiveProps');

        if (nextProps.rows !== this.props.rows) {
            console.log("\t rows: " + (nextProps.rows !== null ? nextProps.rows.length : "NULL"));

            $(this.refs.I18nTable).bootstrapTable('load', nextProps.rows);
        }
    }

    esportaButton() {
        console.log(this.componentName + " esportaButton")
        this.props.getI18nListForExport();
    }

    inputChangeHandler(e, index) {
        if (e !== null && e !== undefined) {
            let value = e.target.value;
            let id = e.target.id;

            this.setState({ searchPar: value });
        }
    }

    filterLocalizzazione() {
        this.props.handleChange('searchPar', this.state.searchPar);
        this.props.filterLocalizzazione();
    }

    render() {
        console.log(this.componentName + 'render');
        return (
            <agui.aCardV4>
                <agui.aCardV4Header>
                    {isAuth('V2.ADMIN.PRODUCT.CREATE') &&
                        <agui.aButton className="float-right mx-3" bs='primary' onClick={this.createI18n} icon="fa fa-plus" inline={true}>Nuovo </agui.aButton>
                    }
                    <agui.aButton bs="primary" className="float-right mx-3" icon="fas fa-file-export" onClick={this.esportaButton}>Export (InLine)</agui.aButton>
                    <agui.aButton bs="primary" className="float-right mx-3" icon="fas fa-file-export" onClick={this.esportaButton}>Export (Row) </agui.aButton>
                    <agui.aButton bs="primary" className="float-right mx-3" icon="fas fa-file-import" onClick={this.esportaButton}>Import (InLine) </agui.aButton>
                    <h3>Lista I18n</h3>
                </agui.aCardV4Header>
                <agui.aCardV4Body>
                    <div className="row">
                        <div className="col col-sm-4 col-md-4 col-lg-4">
                            <agui.ATextInputV4 id="searchPar" type="text"
                                value={this.state.searchPar}
                                placeholder="inserire valore"
                                label="Id"
                                onChange={this.inputChangeHandler} />
                        </div>
                        <div style={{ marginTop: 30, marginLeft: 15, }}  >
                            <agui.aButton className="float-right mx-3" bs='primary' onClick={this.filterLocalizzazione} icon="fas fa-search" inline={true}>Filtra </agui.aButton>
                        </div>
                    </div>
                    <table ref="I18nTable" className={AppConstants.CLASS_TABLE} />
                </agui.aCardV4Body>
            </agui.aCardV4>
        );
    }


}

function mapDispatchToProps(dispatch) {
    return {
        getI18nList() {
            return dispatch(I18nActions.getI18nList());
        },
        newI18N() {
            return dispatch(I18nActions.newI18N());
        },
        getI18nListForExport() {
            return dispatch(I18nActions.getI18nExport());
        },
        filterLocalizzazione() {
            return dispatch(I18nActions.filterLocalizzazione());
        },
        handleChange(id, value) {
            return dispatch(I18nActions.handleChange(id, value));
        },
        clearSearchPar() {
            return dispatch(I18nActions.clearSearchPar());
        }
    };
};

function mapStateToProps(state) {
    return {
        i18n: state.localizzazione.i18n,
        rows: state.localizzazione.listI18n,
        test: state.localizzazione.test,
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(Localizzazione);